const csvCell = (value) => {
  const normalized = value === null || value === undefined ? '' : String(value);
  return /[",\r\n]/.test(normalized) ? `"${normalized.replace(/"/g, '""')}"` : normalized;
};

const exportDate = (value) => {
  if (!value) return '';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? String(value) : date.toISOString();
};

export const buildAssignmentsCsv = (campaignName, assignments) => {
  const rows = [
    ['Campaign', campaignName],
    [],
    ['Student', 'Email', 'Status', 'Assigned at', 'Due at', 'Started at', 'Completed at', 'Score'],
    ...assignments.map((assignment) => [
      assignment.studentName,
      assignment.studentEmail,
      assignment.status,
      exportDate(assignment.assignedAt),
      exportDate(assignment.dueAt),
      exportDate(assignment.startedAt),
      exportDate(assignment.completedAt),
      assignment.score ?? '',
    ]),
  ];

  return rows.map((row) => row.map(csvCell).join(',')).join('\r\n');
};

export const campaignExportFilename = (campaignName) => {
  const safeName = String(campaignName || 'campaign')
    .trim()
    .replace(/[^a-z0-9]+/gi, '-')
    .replace(/^-|-$/g, '')
    .toLowerCase() || 'campaign';
  return `${safeName}-assignments.csv`;
};
